import React from "react";

import { faSparkles } from "@fortawesome/pro-regular-svg-icons";

import { MarkdownRenderer } from "src/base-components/MarkdownRenderer/MarkdownRenderer";
import { CaseBlock, CaseBlockProps } from "src/cases/caseView/CaseBlock";
import { CaseBlockMarkdownData } from "src/cases/queries/casesTypes";
import { EmptyState } from "src/design-system/EmptyState";

type MarkdownBlockProps = Omit<CaseBlockProps, "children"> & {
  data: CaseBlockMarkdownData;
};

export const MarkdownBlock: React.FC<MarkdownBlockProps> = ({
  data,
  ...props
}) => {
  if (!data.content) {
    const isEmpty = data.content === "";
    const headline = isEmpty ? `Content is empty` : `Content not generated yet`;
    const description = isEmpty
      ? "There's currently no content to display"
      : `Once generated, it will be displayed here`;

    return (
      <CaseBlock {...props}>
        <EmptyState
          description={description}
          headline={headline}
          icon={faSparkles}
        />
      </CaseBlock>
    );
  }

  // We use noPaddings and custom padding for the markdown block
  // because we want Table sticky header to work correctly
  // without space above, that's why we use margin-top instead of padding-top
  return (
    <CaseBlock {...props} isExpandable noPaddings>
      <div className="mt-4 px-4 pb-4 font-inter-normal-12px text-gray-800">
        <MarkdownRenderer content={data.content} />
      </div>
    </CaseBlock>
  );
};
